var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.39vw",
    height: "5.39vw",
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.667 48.5006H48.5003V34.6465L39.0003 40.584L29.5003 34.6465V48.5006H26.3337V29.5007H28.2337L39.0003 36.2298L49.767 29.5007H51.667M51.667 26.334H26.3337C24.5762 26.334 23.167 27.7432 23.167 29.5007V48.5006C23.167 49.3405 23.5006 50.146 24.0945 50.7398C24.6884 51.3337 25.4938 51.6673 26.3337 51.6673H51.667C52.5068 51.6673 53.3123 51.3337 53.9062 50.7398C54.5 50.146 54.8337 49.3405 54.8337 48.5006V29.5007C54.8337 28.6608 54.5 27.8553 53.9062 27.2615C53.3123 26.6676 52.5068 26.334 51.667 26.334V26.334Z",
    fill: "#683FDB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.8216,
    cy: 38.8216,
    r: 38.3216,
    stroke: "#683FDB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.687bfcfc9304693a7b8d86afcd62e6f3.svg";
export { ForwardRef as ReactComponent };